// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountAddressModel {
    static getAttributeTypeMap() {
        return AccountAddressModel.attributeTypeMap;
    }
}
AccountAddressModel.discriminator = undefined;
AccountAddressModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "receiverFirstName",
        "baseName": "receiverFirstName",
        "type": "string"
    },
    {
        "name": "receiverLastName",
        "baseName": "receiverLastName",
        "type": "string"
    },
    {
        "name": "addressType",
        "baseName": "addressType",
        "type": "AccountLocationPurposeType"
    },
    {
        "name": "addressOne",
        "baseName": "addressOne",
        "type": "string"
    },
    {
        "name": "addressTwo",
        "baseName": "addressTwo",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
    {
        "name": "country",
        "baseName": "country",
        "type": "string"
    }
];
//# sourceMappingURL=accountAddressModel.js.map